document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.action.includes('/cart/add') || form.closest('product-form')) return;
  if (event.submitter?.name === 'checkout') return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  if (form.dataset.ncBusy === 'true') return;
  form.dataset.ncBusy = 'true';
  const button = event.submitter || form.querySelector('[type="submit"]');
  if (button) button.disabled = true;
  try {
    const data = new FormData(form);
    data.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
    data.set('sections_url', window.location.pathname);
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: data,
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
    drawer.setActiveElement(button || document.activeElement);
    drawer.renderContents(result);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Das Produkt konnte nicht hinzugefügt werden.';
    let alert = form.querySelector('[data-nc-cart-error]');
    if (!alert) {
      alert = document.createElement('p');
      alert.setAttribute('role', 'alert');
      alert.dataset.ncCartError = '';
      form.append(alert);
    }
    alert.textContent = message;
  } finally {
    form.dataset.ncBusy = 'false';
    if (button) button.disabled = false;
  }
}, true);

